module.exports = __webpack_public_path__ + "static/ecrin-b6616527548b878a8410850067f690a2.jpg";